import { render, staticRenderFns } from "./ProblemOptions.vue?vue&type=template&id=420277c9&"
import script from "./ProblemOptions.vue?vue&type=script&lang=js&"
export * from "./ProblemOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports